import { array, number, object, string } from "yup";
import { LanguagesSlugs } from "@typeDefinitions";
import { translationLang } from "@utils/yup_schema";
import {
  FoodGroupResourceDto,
  foodGroupResourceSchema,
} from "./FoodGroupResourceDto";

export interface ProductProgramScheduleResource {
  dietIds: number[];
  product: {
    id: number;
    name: string;
    translations: Translation[];
    measurements: FoodMeasurePivotResource[];
  };
  grams: number;
  mainCategory: FoodGroupResourceDto;
}

interface Translation {
  lang: LanguagesSlugs;
  name: string | null;
}

interface FoodMeasurePivotResource {
  id: number;
  grams: number;
}

const translationSchema = object({
  lang: translationLang,
  name: string().ensure(),
});

const foodMeasurePivotSchema = object({
  id: number().required(),
  grams: number().required(),
});

const productSchema = object({
  id: number().required(),
  name: string().required(),
  translations: array().of(translationSchema).required(),
  measurements: array().of(foodMeasurePivotSchema).required(),
});

export const productProgramScheduleSchema = object().shape({
  product: productSchema.required(),
  grams: number().required(),
  dietIds: array().of(number().required()).required(),
  mainCategory: foodGroupResourceSchema.required(),
});
